@if(mode==='read'){
<div>
    <div nz-row>
        <div nz-col nzSpan="8">Address Line 1</div>
        <div nz-col nzSpan="16">{{ (data && data.street1) ?? ''}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">Address Line 2</div>
        <div nz-col nzSpan="16">{{ (data && data.street2) ?? ''}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">City</div>
        <div nz-col nzSpan="16">{{ (data && data.city) ?? ''}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">State</div>
        <div nz-col nzSpan="16">{{ (data && data.state) ?? ''}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">Zip Code</div>
        <div nz-col nzSpan="16">{{ (data && data.zipCode) ?? ''}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">County</div>
        <div nz-col nzSpan="16">{{ (data && data.countyOrRegion) ?? ''}}</div>
    </div>
    @if(is_permanent){
    <div nz-row style="margin-top:8px">
        <div nz-col nzSpan="8" class="ppl-read-label">Is the Mailing address the same as the Physical Address?</div>
        <div nz-col nzSpan="16">{{data?.mailing ? "Yes" : "No"}}</div>
    </div>
    }
</div>
}
@else{
<div nz-row style="margin-top:8px;margin-bottom:25px">
    <div nz-col nzSpan="8" [nzSm]="8" [nzXs]="24" style="font-weight: 600;">Search Address</div>
    <div class="address-bar" nz-col nzSpan="16">
        <div class="address-field-wrapper">
            <nz-select nzShowSearch nzServerSearch nzPlaceHolder="Start with the street number (e.g., 123 Main…)" [(ngModel)]="selectedValue"
                [nzShowArrow]="false" [nzFilterOption]="nzFilterOptions" (nzOnSearch)="onSearch($event)"
                (ngModelChange)="validateAddress($event)" pplNzAriaLabel
                nzAriaLabel="Search Physical Address, type address and then select value from dropdown">
                @for(option of listOfOptions; track $index){
                <nz-option [nzValue]="option.value" [nzLabel]="option.text"></nz-option>
                }
            </nz-select>
            <i nz-icon nzType="info-circle" nzTheme="outline"
                nz-tooltip="Please begin typing the address with the street number and provide at least four characters."
                class="info-icon">
            </i>
        </div>
        <div class="manual-toggle pt-2">
            <input type="checkbox" id="manualAddressToggle" #manualToggle
                (change)="toggleManualAddress(manualToggle.checked)" />
            <label for="manualAddressToggle">Enter address manually</label>
        </div>
    </div>
</div>
<div cdkScrollable [formGroup]="addressForm">
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="street1" class="ppl-form-label">Address Line 1 @if(isMandatory) {
            <span>*</span> }</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input [ngClass]="{'error': (permanentValidationErrors['street1'] || mailingValidationErrors['street1'] || serviceValidationErrors['street1']) }"
                [attr.aria-invalid]="(permanentValidationErrors['street1'] || mailingValidationErrors['street1'] || serviceValidationErrors['street1']) ? 'true' : 'false'"
                [attr.aria-describedby]="(permanentValidationErrors['street1'] || mailingValidationErrors['street1'] || serviceValidationErrors['street1']) ? 'street1-error' : null"
                nz-input formControlName="street1" id="street1" />
            @if (permanentValidationErrors['street1'] || mailingValidationErrors['street1'] || serviceValidationErrors['street1']) {
            <span id="street1-error" class="pl-1 error-message" role="alert">{{(permanentValidationErrors['street1'] ||
                mailingValidationErrors['street1'] || serviceValidationErrors['street1'])}}</span>
            }
        </nz-form-control>


    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="street2" class="ppl-form-label">Address Line 2</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input nz-input formControlName="street2" id="street2" />
        </nz-form-control>
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="city" class="ppl-form-label">City @if(isMandatory) { <span>*</span>
            }</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input [ngClass]="{'error': (permanentValidationErrors['city'] || mailingValidationErrors['city'] || serviceValidationErrors['city']) }"
                [attr.aria-invalid]="(permanentValidationErrors['city'] || mailingValidationErrors['city'] || serviceValidationErrors['city']) ? 'true' : 'false'"
                [attr.aria-describedby]="(permanentValidationErrors['city'] || mailingValidationErrors['city'] || serviceValidationErrors['city']) ? 'city-error' : null"
                nz-input formControlName="city" id="city" />
            @if (permanentValidationErrors['city'] || mailingValidationErrors['city'] || serviceValidationErrors['city']) {
            <span id="city-error" class="pl-1 error-message" role="alert">{{(permanentValidationErrors['city'] ||
                mailingValidationErrors['city'] || serviceValidationErrors['city'])}}</span>
            }
        </nz-form-control>
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="state" class="ppl-form-label">State @if(isMandatory) {
            <span>*</span> }</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <nz-select formControlName="state" class="ppl-select" nzId="state" nzShowSearch nzAllowClear
                [ngClass]="{'error': permanentValidationErrors['state'] || mailingValidationErrors['state'] || serviceValidationErrors['state'] }"
                [attr.aria-invalid]="(permanentValidationErrors['state'] || mailingValidationErrors['state'] || serviceValidationErrors['state']) ? 'true' : 'false'"
                [attr.aria-describedby]="(permanentValidationErrors['state'] || mailingValidationErrors['state'] || serviceValidationErrors['state']) ? 'state-error' : null">
                @for(opt of statesListDropdown; track $index){
                <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                }
            </nz-select>
            <!-- <input [ngClass]="{'error': (permanentValidationErrors['state'] || mailingValidationErrors['state'])  }" nz-input formControlName="state" id="state" /> -->
            @if (permanentValidationErrors['state'] || mailingValidationErrors['state'] || serviceValidationErrors['state']) {
            <span id="state-error" class="pl-1 error-message" role="alert">{{(permanentValidationErrors['state'] ||
                mailingValidationErrors['state'] || serviceValidationErrors['state'])}}</span>
            }
        </nz-form-control>
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="zipCode" class="ppl-form-label">Zip Code @if(isMandatory) {
            <span>*</span> }</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input [ngClass]="{'error': (permanentValidationErrors['zipCode'] || mailingValidationErrors['zipCode'] || serviceValidationErrors['zipCode'])  }"
                [attr.aria-invalid]="(permanentValidationErrors['street1'] || mailingValidationErrors['street1'] || serviceValidationErrors['zipCode']) ? 'true' : 'false'"
                [attr.aria-describedby]="(permanentValidationErrors['street1'] || mailingValidationErrors['street1'] || serviceValidationErrors['zipCode']) ? 'street1-error' : null"
                nz-input formControlName="zipCode" id="zipCode" />
            @if (permanentValidationErrors['zipCode'] || mailingValidationErrors['zipCode'] || serviceValidationErrors['zipCode']) {
            <span id="street1-error" class="pl-1 error-message" role="alert">{{permanentValidationErrors['zipCode'] ||
                mailingValidationErrors['zipCode'] || serviceValidationErrors['zipCode']}}</span>
            }
        </nz-form-control>
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="region" class="ppl-form-label">County
            @if(isMandatory) { <span>*</span> }</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input
                [ngClass]="{'error': (permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion'] || serviceValidationErrors['countyOrRegion']) }"
                [attr.aria-invalid]="(permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion'] || serviceValidationErrors['countyOrRegion']) ? 'true' : 'false'"
                [attr.aria-describedby]="(permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion'] || serviceValidationErrors['countyOrRegion']) ? 'countyOrRegion-error' : null"
                nz-input formControlName="countyOrRegion" id="countyOrRegion" aria-label="County or Region" />
            @if (permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion'] || serviceValidationErrors['countyOrRegion']) {
            <span id="countyOrRegion-error" class="pl-1 error-message"
                role="alert">{{permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion'] || serviceValidationErrors['countyOrRegion']
                }}</span>
            }
        </nz-form-control>
    </nz-form-item>
    @if(is_permanent){
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="14" [nzXs]="24" nzFor="mailing" class="ppl-form-label">Is the Mailing address the same
            as the Physical Address?</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <nz-switch nzId="mailing" formControlName="mailing" pplNzAriaLabel [attr.role]="'switch'"
                [attr.aria-checked]="addressForm.get('mailing')?.value ? 'true' : 'false'"
                nzAriaLabel="Is the Mailing address the same as the Physical Address"></nz-switch>
        </nz-form-control>
    </nz-form-item>
    }
</div>
}